import { Deal } from 'app/models/dto/deal.model';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import { Document } from 'app/models/dto/document.model';

export class GetDealDocumentRequirements {
	static readonly type = '[DealDocuments] GetDealDocumentRequirements';
	constructor(public deal: Deal, public loanProductId: number) {}
}

export class ClearDealDocumentRequirements {
	static readonly type = '[DealDocuments] ClearDealDocumentRequirements';
	constructor() {}
}

export class SetDocumentRequirementsMet {
	static readonly type = '[DealDocuments] SetDocumentRequirementsMet';
	constructor(public dealId: number) {}
}

export class AddDocumentCategory {
	static readonly type = '[DealDocuments] AddDocumentCategory';
	constructor(public dealId: number, public documentCategory: DocumentCategory) {}
}

export class AttachDealDocument {
	static readonly type = '[DealDocuments] AttachDealDocument';
	constructor(public dealId: number, public document: Document, public requirementGroup: string) {}
}

export class DetachDealDocument {
	static readonly type = '[DealDocuments] DetachDealDocument';
	constructor(public dealId: number, public document: Document, public requirementGroup: string) {}
}

export class UploadDealDocument {
	static readonly type = '[DealDocuments] UploadDealDocument';
	constructor(
    public file: File,
    public borrowerId: number,
    public dealId: number,
    public category: string,
    public requirementGroup: string
  ) {}
}
